<template>
  <v-navigation-drawer
    v-model="drawer"
    width="450px"
    height="750"
    absolute
    temporary
    right
  >
    <v-container fluid class="lighten-12">
      <v-row>
        <v-col cols="12" style="padding: 0">
          <v-row>
            <v-col cols="12" style="text-align: center; padding: 0">
              <span class="paymentheader"><b>Payment</b></span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-select
              v-model="sale_type"
              :disabled="Customer == 1"
              :items="PaymentTypes"
              hide-details="auto"
              item-text="name"
              class="ma-2"
              item-value="value"
              label="Sale Type"
              outlined
              dense
              :error-messages="errors"
            >
            </v-select>
          </v-row>
        </v-col>
        <v-col cols="12" style="padding: 0 0px 4px 0px">
          <v-row style="background: #13928e">
            <v-col cols="6" class="subhead">Sub Total</v-col>
            <v-col cols="6" class="subhead">{{
              GetSubTotalAmount | formatCurrency
            }}</v-col>
          </v-row>
          <v-row style="background: #0d6666">
            <v-col cols="6" class="subhead">Discount</v-col>
            <v-col cols="6" class="subhead">{{
              GetDiscountAmount | formatCurrency
            }}</v-col>
          </v-row>
          <v-row style="background: #063232">
            <v-col cols="6" class="subhead">Total</v-col>
            <v-col cols="6" class="subhead">{{
              (GetSubTotalAmount - GetDiscountAmount) | formatCurrency
            }}</v-col>
          </v-row>
        </v-col>
        <v-col cols="12" style="padding: 0">
          <v-card class="boxstyle">
            <v-container>
              <v-row>
                <v-row v-for="(item, index) in PaymentDatas" :key="index">
                  <v-col cols="12">
                    <v-card class="boxstyle">
                      <v-row>
                        <v-col cols="5">
                          <v-select
                            :value="item.payment_type"
                            :items="sale_types"
                            hide-details="auto"
                            item-text="name"
                            class="ma-2"
                            item-value="value"
                            label="Type"
                            outlined
                            dense
                            :error-messages="errors"
                          >
                            <template v-slot:item="{ item, attrs, on }">
                              <v-list-item
                                v-bind="attrs"
                                v-on="on"
                                @click="updatepaymentType($event, index, item)"
                              >
                                <v-list-item-title
                                  :id="attrs['aria-labelledby']"
                                  v-text="item.name"
                                ></v-list-item-title>
                              </v-list-item>
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="5">
                          <v-text-field
                            :value="item.amount"
                            hide-details="auto"
                            class="ma-2"
                            label="Price"
                            min="0"
                            type="number"
                            oninput="validity.valid||(value='');"
                            outlined
                            @input="
                              updatepaymentTypeAmount($event, index, item)
                            "
                            dense
                            :error-messages="errors"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="2">
                          <v-row>
                            <v-col style="display: flex; padding: 0px">
                              <v-icon
                                style="
                                  color: green;
                                  font-size: 18px !important;
                                  margin-top: 16px;
                                "
                                class="icon_large"
                                v-bind="attrs"
                                @click="addAnotherPayment(item)"
                                v-on="on"
                                >mdi-plus-box</v-icon
                              >
                              <v-icon
                                v-if="index != 0 || PaymentDatas.length > 1"
                                style="
                                  color: red;
                                  font-size: 18px !important;
                                  margin-top: 16px;
                                "
                                class="icon_large ml-2"
                                v-bind="attrs"
                                @click="removePayment(item, index)"
                                v-on="on"
                                >mdi-delete</v-icon
                              >
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>

                  <v-col cols="12" v-if="item.payment_type == 'Cheque'">
                    <v-card class="boxstyle">
                      <v-container>
                        <v-row>
                          <v-col cols="6" style="padding: 0; margin-top: 8px">
                            <datePickComponent
                              :value="item.cheque_date"
                              hide-details="auto"
                              :labelname="'Date'"
                              @input="updateChequeDate($event, index, item)"
                              style="margin: 8px !important"
                              outlined
                              :error-messages="errors"
                            >
                            </datePickComponent>
                          </v-col>
                          <v-col cols="6" style="padding: 0">
                            <v-select
                              :value="item.cheque_type"
                              :items="cheque_types"
                              hide-details="auto"
                              item-text="name"
                              class="ma-2"
                              item-value="value"
                              label="Type"
                              outlined
                              dense
                              :error-messages="errors"
                            >
                              <template v-slot:item="{ item, attrs, on }">
                                <v-list-item
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="updateChequeType($event, index, item)"
                                >
                                  <v-list-item-title
                                    :id="attrs['aria-labelledby']"
                                    v-text="item.name"
                                  ></v-list-item-title>
                                </v-list-item>
                              </template>
                            </v-select>
                          </v-col>
                          <v-col cols="12" style="padding: 0">
                            <v-text-field
                              :value="item.cheque_no"
                              hide-details="auto"
                              class="ma-2"
                              label="Number"
                              outlined
                              dense
                              @input="updateChequeNumber($event, index, item)"
                              :error-messages="errors"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" style="padding: 0">
                            <v-text-field
                              :value="item.cheque_bank"
                              hide-details="auto"
                              class="ma-2"
                              label="Bank"
                              outlined
                              dense
                              @input="updateChequeBank($event, index, item)"
                              :error-messages="errors"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" style="padding: 2px 0px 12px 0px">
          <v-text-field
            v-model="receivedamount"
            hide-details="auto"
            class="ma-2"
            label="ReceivedAmount"
            outlined
            min="0"
            type="number"
            oninput="validity.valid||(value='');"
            dense
            :error-messages="errors"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" style="padding: 0 0px 8px 0px">
          <v-row style="background: #0d6666">
            <v-col
              cols="6"
              class="subhead"
              v-if="totalSalesAmount - receivedamount <= 0"
              >Balance</v-col
            >
            <v-col
              cols="6"
              class="subhead"
              v-if="totalSalesAmount - receivedamount > 0"
              >Payable Amount</v-col
            >
            <v-col
              cols="6"
              class="subhead"
              v-if="totalSalesAmount - receivedamount <= 0"
              >{{ (receivedamount - totalSalesAmount) | formatCurrency }}</v-col
            >
            <v-col
              cols="6"
              class="subhead"
              v-if="totalSalesAmount - receivedamount > 0"
              >{{ (totalSalesAmount - receivedamount) | formatCurrency }}</v-col
            >
          </v-row>
        </v-col>
        <v-col cols="12" style="padding: 0 0px 2px 0px">
          <v-col cols="12">
            <v-btn
              depressed
              :disabled="Paymentclicked"
              style="
                width: 455px;
                height: 43px !important;
                right: 19px;
                background: #007bff;
                color: white;
              "
              class="text-white btn_medium submitbutton"
              @click="openPaymentSection"
              >Submit</v-btn
            >
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>
<script>
import { mapState } from 'vuex';
import datePickComponent from '@/components/base/DateComponent';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  methods: {
    openPaymentSection() {
      // this.Paymentclicked=true;
      this.$emit('setPaymentDetails', {
        receivedamount: this.receivedamount,
        sale_type: this.sale_type,
        items: this.StoredProducts,
        payment: this.PaymentDatas,
      });
    },

    SetTotalAmount(newValue) {
      this.$store.commit('UPDATE_TOTAL_AMOUNT', {
        amount: newValue,
      });
    },
    addAnotherPayment(index) {
      this.$store.commit('ADD_ANOTHER_PAYMENT_TYPE', {
        index: index,
      });
    },
    removePayment(item, index) {
      this.$store.commit('REMOVE_PAYMENT_TYPE', {
        index: index,
      });
    },
    updateChequeNumber(newValue, index, item) {
      this.$store.commit('UPDATE_PAYMENT_CHEQUENUMBER', {
        number: newValue,
        index: index,
      });
    },
    updateChequeBank(newValue, index, item) {
      this.$store.commit('UPDATE_PAYMENT_CHEQUEBANK', {
        bank: newValue,
        index: index,
      });
    },
    updateChequeType(newValue, index, item) {
      this.$store.commit('UPDATE_PAYMENT_CHEQUETYPE', {
        type: item.value,

        index: index,
      });
    },
    updateChequeDate(newValue, index, item) {
      this.$store.commit('UPDATE_PAYMENT_CHEQUEDATE', {
        date: newValue,
        index: index,
      });
    },
    updatepaymentType(newValue, index, item) {
      this.$store.commit('UPDATE_PAYMENT_TYPE', {
        paymentType: item.value,
        index: index,
        date: this.Today,
      });
    },
    updatepaymentTypeAmount(newValue, index, item) {
      this.$store.commit('UPDATE_PAYMENT_AMOUNT', {
        amount: newValue,
        index: index,
      });
    },
    // firstTimeSetPayment(newValue) {
    //   this.$store.commit("UPDATE_PAYMENT_AMOUNT_FIRST", {
    //     amount: newValue,
    //     index: index,
    //   });
    // },
  },
  //  mounted: function() {
  //   this.SetTotalAmount(this.GetTotalAmount);
  // },
  props: {
    Paymentclicked: {
      type: Boolean,
      default: false,
    },
    Customer: {
      type: Object,
      default: null,
    },
    drawer: {
      type: String,
      default: null,
    },
  },

  components: {
    datePickComponent,
  },

  computed: {
    ...mapState(['PaymentDatas']),
    ...mapState(['StoredProducts']),
    ...mapState(['totalSalesAmount']),
    ...mapGetters(['GetDiscountAmount']),
    ...mapGetters(['GetTotalAmount']),
    ...mapGetters(['GetSubTotalAmount']),
  },
  data: () => ({
    payment: { sale_type: 'credit' },
    Today: moment(new Date()).format('YYYY-MM-DD'),
    payment: { sale_type: 'credit' },
    sale_type: 'cash',
    receivedamount: 0,

    PaymentTypes: [
      { name: 'Cash', value: 'cash' },
      { name: 'Credit', value: 'credit' },
    ],
    sale_types: [
      { name: 'Cash', value: 'Cash' },
      { name: 'Card', value: 'Card' },
      { name: 'Cheque', value: 'Cheque' },
      { name: 'Other', value: 'Other' },
    ],
    cheque_types: [
      { name: 'Cross', value: 'Cross' },
      { name: 'Cash', value: 'Cash' },
    ],
  }),
};
</script>
<style scoped>
.subhead {
  font-size: 15px;
  color: white;
  font-weight: 500px;
}
.paymentheader {
  font-size: 23px;
  font-weight: 1200px;
}
.submitbutton {
  font-size: 23px;
  font-weight: 1200px;
}
.anotherpayment {
  height: 27px;
  font-weight: 700;
  width: 145px;
  font-size: 13px;
  text-align: center;
  border-radius: 5px;
  background-color: coral;
}
.boxstyle {
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
